var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      class: {
        active: _vm.active,
        selected: _vm.selected,
        deleted: _vm.productTask.productOrder.deleted
      },
      on: {
        click: function($event) {
          return _vm.$emit("task-clicked")
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "badges mb-2" },
        [
          _vm.productTask.order.priority !== 0
            ? _c(
                "b-badge",
                { staticClass: "badge mr-1", attrs: { variant: "danger" } },
                [
                  _c("icon", { attrs: { name: "exclamation" } }),
                  _vm._v(" Срочно")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.productTask.order.typeDelivery.keyword ===
          _vm.TYPE_DELIVERY.PICKUP
            ? _c(
                "b-badge",
                { staticClass: "badge", attrs: { variant: "warning" } },
                [
                  _c("icon", { attrs: { name: "truck-pickup" } }),
                  _vm._v(" Самовывоз")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.productTask.order.forTime !== null
            ? _c(
                "b-badge",
                { staticClass: "badge" },
                [
                  _c("icon", { staticClass: "mr-2", attrs: { name: "clock" } }),
                  _vm._v("На время: " + _vm._s(_vm.productTask.order.forTime))
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("h4", [_vm._v("Заказ #" + _vm._s(_vm.productTask.order.idDay))]),
      _vm._v(" "),
      _vm.active
        ? _c(
            "h5",
            [
              _vm.userRole === _vm.roles.USER_ROLE_PIZZA_DOUGH
                ? [
                    _vm._v(
                      _vm._s(_vm.getPizzaSize(_vm.productTask)) +
                        _vm._s(_vm.getNumberOfDough(_vm.productTask))
                    )
                  ]
                : [
                    _vm._v(
                      _vm._s(
                        _vm.productTask.order.brandName +
                          " - " +
                          _vm.productTask.productOrder.name
                      ) + _vm._s(_vm.getNumberOfPizza(_vm.productTask))
                    )
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h6", [_vm._v(_vm._s(_vm.productTask.time))]),
      _vm._v(" "),
      _vm._l(
        JSON.parse(_vm.productTask.productOrder.product.composition),
        function(prD) {
          return _vm.userRole === _vm.roles.USER_ROLE_PIZZA_COOKER && _vm.active
            ? _c(
                "b-list-group",
                { key: prD, staticClass: "d-inline-flex" },
                [
                  _c("b-card", { attrs: { "no-body": "" } }, [
                    _c("p", { staticClass: "descriptProduct" }, [
                      _vm._v(_vm._s(prD))
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        }
      ),
      _vm._v(" "),
      _c("div", [
        _vm.productTask.order.kitchenComment
          ? _c("span", { staticClass: "comment" }, [
              _vm._v(_vm._s(_vm.productTask.order.kitchenComment))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mb-1" },
        [
          _vm.spinning
            ? _c("b-spinner", {
                attrs: { label: "Spinning", variant: "success" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3afefd5d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3afefd5d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskProductItem.vue
// module id = null
// module chunks = 